// src/components/About.js
import React from "react";
import "../styles/about.css";
import logo from "../assets/logo.png";

const About = () => {
  return (
    <div className="container about">
      <div className="about-left fade-in">
        <p className="section-title">O nama</p>
        <h2 className="section-heading">KBIA poklon kutije</h2>
        <p className="section-subtitle">
          KBIA poklon kutije osnovana je 2019. godine kao mali obrt za izradu
          personaliziranih poklona. Danas izrađujemo poklon kutije, zahvalnice,
          revere i druge proizvode za vjenčanja, krštenja, krizme, promocije,
          rođendane i mnoge druge prigode.
        </p>
        <p className="about-text">
          U svaki proizvod ulažemo puno truda i ljubavi, a naše iskustvo,
          kvaliteta materijala i posvećenost izradi jamče da ćete dobiti
          jedinstven poklon za svoje voljene.
        </p>
      </div>

      <div className="about-right fade-in">
        <div className="about-card">
          <img src={logo} alt="KBIA logo" className="about-logo" />
          <div className="about-badge">Od 2019.</div>
          <p className="about-card-text">
            Svaki proizvod koji izradimo prolazi kroz naše ruke, od izrade
            dizajna do posljednje mašnice, sve radimo ručno. Vjerujemo da poklon
            nije samo predmet, već uspomena.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
